import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const employeeWorkShiftCreateService = (
  params: Types.EmployeeWorkShiftCreateRequest
) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const employeeWorkShiftListService = (
  params: Types.EmployeeWorkShiftListRequest
) =>
  RestAPIClient.call<Types.EmployeeWorkShiftListResponse>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.List?.replace("{empId}", (params.id as never) || "")}`,
    config: {
      requireAuthentication: true,
      params,
    },
  });
